<template>

<el-scrollbar max-height="600px">
    <el-button type="success" circle  class="chapterBtn" @click="addChapterForm = true" >
      <el-icon><Plus /></el-icon>
    </el-button>

    <el-dialog
    v-model="addChapterForm"
    title="添加章节"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="chapterName" class="col-sm-2 col-form-label">章节名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="chapterName"/>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="addChapterForm = false">取消</el-button>
        <el-button type="submit" @click="addChapter();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


  <!-- 修改章节表单 -->
  <el-dialog
    v-model="editChapterForm"
    title="修改章节"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="chapterName" class="col-sm-2 col-form-label">章节名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="chapterName"
            :value="chapterName"
            />
            <input type="hidden" id="chapterId" :value="chapterId">
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editChapterForm = false">取消</el-button>
        <el-button type="submit" @click="editChapterOk();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 修改资料表单 -->
  <el-dialog
    v-model="editdataForm"
    title="修改资料"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="dataName" class="col-sm-2 col-form-label">资料名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="dataName"
            :value="dataName"
            />
            <input type="hidden" id="dataId" :value="dataId">
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editdataForm = false">取消</el-button>
        <el-button type="submit" @click="editDataOk();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 添加资料表单 -->
  <el-dialog
    v-model="addDataForm"
    title="添加资料"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="DataName" class="col-sm-2 col-form-label">资料名</label>
        <div class="col-sm-9">
          <input
            type="text"
            class="form-control"
            id="DataName"
            />
            <input type="hidden" id="addDataChapterId" :value="addDataChapterId">
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>

      <div class="mb-3 row">
        <label for="dataType" class="col-sm-2 col-form-label">类型</label>
        <div class="col-sm-9">
          <select
            class="form-select"
            id="dataType"
            name="dataType"
            v-model="dataType"
          >
            <option value="0" selected>视频</option>
            <option value="1">PPT</option>
            <option value="2">DOCX</option>
            <option value="3">其他</option>
          </select>
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>

      <div class="mb-3 row">
        <label for="data" class="col-sm-2 col-form-label">资料</label>
        <div class="col-sm-9">
          <input class="form-control" type="file" id="data" />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>

    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="addDataForm = false">取消</el-button>
        <el-button type="submit" @click="addDataOk()"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


   目录
    <div class="demo-collapse">
    <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item :title="chapter.chapterName" :name="chapter.chapterId" v-for="chapter in chapters" :key="chapter.chapterId">
          <div>
            <el-popconfirm
            title="确认要删除吗？"
            @confirm="deleteChapter(chapter.chapterId)"
            confirm-button-text="确认"
            cancel-button-text="取消"
            confirm-button-type="danger"
          >
            <template #reference>
              <el-button type="danger" class="chapterBtn" plain>
                <el-icon><Delete/></el-icon>
            </el-button>
            </template>
          </el-popconfirm>

            <el-button type="success" class="chapterBtn" @click="addData(chapter.chapterId);" plain>
                <el-icon><CirclePlus/></el-icon>
            </el-button>

            <el-button type="primary" class="chapterBtn" @click="editChapter(chapter.chapterName, chapter.chapterId);" plain>
                <el-icon><Edit/></el-icon>
            </el-button>
            <br><hr>
        </div>

        <div v-for="data in chapter.data" :key="data.dataId">

          <div class="dataBorder">
            <img src="@/assets/img/card/video.png" class="dataImg" v-if="data.dataType == 0">
            <img src="@/assets/img/card/ppt.png" class="dataImg" v-if="data.dataType == 1">
            <img src="@/assets/img/card/docx.png" class="dataImg" v-if="data.dataType == 2">
            <img src="@/assets/img/card/other.png" class="dataImg" v-if="data.dataType == 3">
            <span class="dataFont">{{ data.dataName }}</span>
          
          
              <el-popconfirm
              title="确认要删除吗？"
              @confirm="deleteData(data.dataId, data.dataType, data.dataLink)"
              confirm-button-text="确认"
              cancel-button-text="取消"
              confirm-button-type="danger"
            >
              <template #reference>
                <el-button type="danger" icon="Delete" class="dataBtn" circle></el-button>
              </template>
            </el-popconfirm>
            
            <router-link :to="'/video/' + courseId + '/' + data.dataLink" target="_blank">
              <el-button type="warning" icon="VideoPlay" class="dataBtn" v-if="data.dataType == 0" circle>
              </el-button>
            </router-link>
            <el-button type="success" icon="Download" class="dataBtn" v-if="data.dataType != 0" circle @click="download(data.dataLink)"></el-button>
            <el-button type="primary" icon="Edit" class="dataBtn" @click="editData(data.dataId, data.dataName);" circle></el-button>

          </div>
          
        </div>
        </el-collapse-item>
    </el-collapse>
    </div>
</el-scrollbar>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import $ from 'jquery';
import { ElLoading } from 'element-plus'

const Route = useRoute(); //获取到值
const courseId = ref("");
let chapters = ref([]);
const addChapterForm = ref(false);
const editChapterForm = ref(false);
const addDataForm = ref(false);
const editdataForm = ref(false);


let dataType = ref(0);
let chapterName = ref("");
let chapterId = ref("");
let addDataChapterId = ref("");
let dataName = ref("");
let dataId = ref("");


onMounted(() => {
  courseId.value = Route.params.courseId;
  pullChapterList();
});


// 拉取章节列表
const pullChapterList = () => {
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/chapter/getChapterList",
        data: {
            courseId: courseId.value,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
         // console.log(resp.data);
        if (resp.code == "200") {
            chapters.value = resp.data;
        } else {
            ElMessage({
            type: "error",
            message: "拉取章节失败",
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "拉取章节失败",
        });
        },
    });
}

// 添加章节
const addChapter = () => {
    let chapterName = $("#chapterName").val();
    if (chapterName == "") {
        ElMessage({
          type: "error",
          message: "请填写章节名!",
        });
        return false;
    }
    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/chapter/addChapter",
        data: {
            courseId: courseId.value,
            chapterName: chapterName,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
        if (resp.code == "200") {
            ElMessage({
            type: "success",
            message: resp.msg,
            });
        } else {
            ElMessage({
            type: "error",
            message: resp.msg,
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "添加章节失败",
        });
        },
    });
    addChapterForm.value = false;
    setTimeout(() => {
        pullChapterList();
    }, 200); // 20
}

const editChapter = (name, id) => {
    editChapterForm.value = true;
    chapterName = name;
    chapterId = id;
}

const editChapterOk = () => {
    const token = localStorage.getItem("token");
    let name = $("#chapterName").val();
    let id = $("#chapterId").val();
    if (name == "") {
        ElMessage({
            type: "error",
            message: "章节不能为空",
        });
    }
    $.ajax({
        url: "http://124.222.105.205:5000/api/chapter/editChapter",
        data: {
            chapterId: id,
            chapterName: name
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
        if (resp.code == "200") {
            chapters.value = resp.data;
            ElMessage({
            type: "success",
            message: resp.msg,
            });
        } else {
            ElMessage({
            type: "error",
            message: resp.msg,
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "修改章节失败",
        });
        },
    });
    editChapterForm.value = false;
    setTimeout(() => {
        pullChapterList();
    }, 200); // 20
}

const addData = (id) => {
  addDataForm.value = true;
  addDataChapterId = id;
}
 
const addDataOk = () => {
  let name = $("#DataName").val();
    if (name == "") {
        ElMessage({
            type: "error",
            message: "资料名不能为空",
        });
        return false;
    }
   
  // 判断资料
  if ($("#data")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "资料未上传！",
    });
    return false;
  }


  var formData = new FormData();
  formData.append("file", $("#data")[0].files[0]); // 资料
  formData.append("dataName", name); // 资料名
  formData.append("dataType", dataType.value); // 资料属性
  formData.append("chapterId", $("#addDataChapterId").val()); // 章节id
  formData.append("courseId", courseId.value); // 课程id
  
  addDataForm.value = false;
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  const token = localStorage.getItem("token");
  $.ajax({
      url: "http://124.222.105.205:5000/api/data/addData",
      type: "post",
      data: formData,
      headers: {
        Authorization: "Bearer " + token,
      },
      processData: false, // 告诉jQuery不要去处理发送的数据
      contentType: false, // 告诉jQuery不要去设置Content-Type请求头
      dataType: "text",
      success: function (resp) {
        let result = JSON.parse(resp);
        if (result.code == "200") {
          ElMessage({
            type: "success",
            message: result.msg,
          });
          location.reload();
        } else {
          ElMessage({
            type: "error",
            message: result.msg,
          });
        }
        loading.close();
      },
      error: function () {
        ElMessage({
          type: "error",
          message: "添加课程资料失败！",
        });
        loading.close();
      },
    });

}

const download = (link) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

const editData = (id, name) => {
  editdataForm.value = true;
    dataName = name;
    dataId = id;
}

const editDataOk = () => {
    const token = localStorage.getItem("token");
    let name = $("#dataName").val();
    let id = $("#dataId").val();
    if (name == "") {
        ElMessage({
            type: "error",
            message: "资料名不能为空",
        });
    }
    $.ajax({
        url: "http://124.222.105.205:5000/api/data/editData",
        data: {
            dataId: id,
            dataName: name
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
        if (resp.code == "200") {
            chapters.value = resp.data;
            ElMessage({
            type: "success",
            message: resp.msg,
            });
        } else {
            ElMessage({
            type: "error",
            message: resp.msg,
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "修改资料失败",
        });
        },
    });
    editdataForm.value = false;
    setTimeout(() => {
        pullChapterList();
    }, 200); // 20
}

const deleteChapter = (id) => {
  const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/chapter/deleteChapter",
        data: {
            chapterId: id,
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
        if (resp.code == "200") {
            ElMessage({
            type: "success",
            message: resp.msg,
            });
        } else {
            ElMessage({
            type: "error",
            message: resp.msg,
            });
        }
        },
        error() {
        ElMessage({
            type: "error",
            message: "删除章节失败",
        });
        },
    });
    setTimeout(() => {
        pullChapterList();
    }, 200); // 20
}

const deleteData = (id, type, link) => {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/detele/deleteData",
        data: {
            dataId: id,
            dataType: type,
            dataLink: link
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
        if (resp.code == "200") {
            ElMessage({
            type: "success",
            message: resp.msg,
            });
        } else {
            ElMessage({
            type: "error",
            message: resp.msg,
            });
        }
        loading.close();
        },
        error() {
        ElMessage({
            type: "error",
            message: "删除资料失败",
        });
        loading.close();
        },
    });
    setTimeout(() => {
        pullChapterList();
    }, 200); // 20
}


</script>

<style scoped>
.chapterBtn {
  float: right;
  margin-right: 20px;
}

.dataImg {
  width: 70px;
  height: 60px;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.dataFont {
  font-size: medium;
  font-weight:bold ;
  padding-left:50px;
}

.dataBorder {
  margin: 5px;
  background-color: rgba(255, 255, 255, 0.821);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
}

.dataBorder:hover{
  margin: 5px;
  background-color: rgba(225, 225, 225, 0.389);
  border: 1px solid rgb(174, 174, 174);
  border-radius: 20px;
  transition: 200ms;
}

.dataBtn {
  float: right;
  margin-right: 20px;
  margin-top: 10px;
  margin-bottom: 5px;
}

</style>